import { useCountdown } from './use-countdown';
import type { UseCountdownProps } from './use-countdown';

export const useFormattedCountdown = ({
  timeoutMs = 0,
  loop = false,
  enabled,
  onFinish,
}: UseCountdownProps) => {
  const { countdown, finished, restart } = useCountdown({
    timeoutMs,
    loop,
    enabled,
    onFinish,
  });

  const days = Math.floor(countdown / (60 * 60 * 24));
  const hours = Math.floor((countdown % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((countdown % (60 * 60)) / 60);
  const seconds = Math.floor(countdown % 60);

  const timer = {
    days: days.toString().padStart(2, '0'),
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };

  return {
    finished,
    restart,
    ...timer,
  };
};
